import { Dispatch } from 'react-redux';
import ReaderApi from './ReaderApi';
import { GalleryInfosActionKeys } from '../../containers/Gallery/actions';
import store from '../../store';
import { StoreState } from '../../reducers/index';

export class BackofficeModeManager {
	constructor(dispatch: Dispatch<StoreState>) {
		const readerApi = new ReaderApi();
		readerApi.init().then((response) => {

			readerApi.addListener('brand.getObject', (response) => {
				const storeState = store.getState();
				const template = storeState.galleryInfos.template;
				if (template && template.brand && template.brand) {
					const { logo, url } = template.brand;
					response.resolve({
						logo,
						url,
					});
				}
			});

			readerApi.addListener('brand.update', (data) => {
				data.resolve(dispatch({
					type: GalleryInfosActionKeys.UPDATE_TEMPLATE_BRAND,
					value: data.arguments[0],
				}));
			});

			readerApi.addListener('commonStyles.getObject', (response) => {
				const storeState = store.getState();
				const template = storeState.galleryInfos.template;
				if (template && template.commonStyles) {
					response.resolve(template.commonStyles);
				}
			});

			readerApi.addListener('commonStyles.update', (data) => {
				data.resolve(dispatch({
					type: GalleryInfosActionKeys.UPDATE_TEMPLATE_COMMONSTYLES,
					value: data.arguments[0],
				}));

			});
		});
	}
}

export default BackofficeModeManager;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/iframeApi/BackofficeModeManager.ts